import {
  Avatar,
  HStack,
  MenuButton,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsChevronDown } from "react-icons/all";

import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  userName: string;
  toggleMenu: () => void;
}

const UserMenuButton = ({ userName, toggleMenu }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.black, colors.white);
  const backgroundHoverColor = useColorModeValue(
    colors.gray[200],
    colors.gray[500]
  );
  return (
    <MenuButton
      px={4}
      py={2}
      borderRadius={8}
      _hover={{ bg: backgroundHoverColor }}
      onClick={() => {
        toggleMenu();
      }}
    >
      <HStack>
        <Avatar name={userName} />
        <Icon color={iconColor} icon={BsChevronDown} />
      </HStack>
    </MenuButton>
  );
};

export { UserMenuButton };
